<template>
  <div class="bg-white">
    <div class="d-flex">
      <div class="wd-300">
        <vue-custom-scrollbar
          :style="`height: ${getScrollHeight()}`"
          class="pd-10"
        >
          <label
            class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-t-5 mg-l-5"
            >Овог</label
          >
          <div class="pd-x-5 mg-b-10">
            <input
              v-model="dnmcSrch.lastName"
              type="text"
              class="form-control input-sm"
            />
          </div>
          <label
            class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-t-5 mg-l-5"
            >Нэр</label
          >
          <div class="pd-x-5 mg-b-10">
            <input
              v-model="dnmcSrch.firstName"
              type="text"
              class="form-control input-sm"
            />
          </div>
          <label
            class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-t-5 mg-l-5"
            >Регистр</label
          >
          <div class="pd-x-5 mg-b-10">
            <input
              v-model="dnmcSrch.register"
              type="text"
              class="form-control input-sm"
            />
          </div>
          <label
            class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-t-5 mg-l-5"
            >Гишүүн №</label
          >
          <div class="pd-x-5 mg-b-10">
            <input
              v-model="dnmcSrch.loginName"
              type="text"
              class="form-control input-sm"
            />
          </div>
          <!-- <label
            class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-t-5 mg-l-5"
          >И-мэйл</label>
          <div class="pd-x-5 mg-b-10">
            <input type="text" class="form-control input-sm" />
          </div>
          <label
            class="tx-10 tx-medium tx-spacing-1 tx-color-03 tx-uppercase tx-sans mg-t-5 mg-l-5"
          >Албан тушаал</label>
          <div class="pd-x-5 mg-b-10">
            <input type="text" class="form-control input-sm" />
          </div> -->

          <div class="btn-group wd-100p">
            <button @click="search()" class="btn btn-outline-light">
              Хайх
            </button>
            <button @click="reset()" class="btn btn-outline-light">Бүгд</button>
          </div>
        </vue-custom-scrollbar>
      </div>
      <div v-if="rdy" class style="width: calc(100vw - 300px)">
        <div class="d-flex align-items-center ht-30 bg-gray-400">
          <div class style="width: calc(50%)">Хэрэглэгч</div>
          <div class="wd-100">Оноо</div>
          <div class="wd-100">Шалгалтын дүн</div>
          <template v-if="config.course.solveResult == 1">
            <div class="wd-100">Ирц ({{ config.course.irtsPerc }}%)</div>
            <div class="wd-100">Явц ({{ config.course.yavtsPerc }}%)</div>
            <div class="wd-100">Дүн ({{ config.course.examPerc }}%)</div>
          </template>
          <div class="wd-100">Нэмэлт оноо</div>
          <div class="wd-150">Сертификатын дүн</div>
          <div class="wd-100">Цэс</div>
        </div>
        <virtual-list
          class="list-group pd-0-f wd-100p"
          :style="`height: ${getScrollHeightMain()}; overflow-y: auto;`"
          :data-key="'userId'"
          :data-sources="users"
          :data-component="ItemUser"
          :keeps="30"
          :estimate-size="20"
          :extra-props="{ config: config }"
          :key="listKey"
          @on-remove="onRemove"
          @on-notification="onNotification"
          @on-filled="onFilled"
          @on-certificate="onCertificate"
          @on-certificate-re="onCertificateRe"
          @on-change-shareflag="onChangeShareflag"
          @on-point="onPoint"
        />
      </div>
    </div>

    <b-modal
      v-model="mdlAlertDeleteLog.show"
      title="Мэдээлэл татсан лог устгах"
      hide-footer
    >
      <div class="p-md">
        Мэдээлэл татсан лог бичилтийг устгахдаа итгэлтэй байна уу.
        <br />Тухайн хүн давхар өгөгдөл илгээх эрсдэлтэй ба системийн зүгээс уг
        тохиолдолд хариуцлага хүлээхгүй болохыг анхаарна уу. <br />Лог устгасан
        тухай лог бичилт мөн үүсэхгүй болохыг анхаарна уу.
      </div>
      <div class="text-center pd-t-10">
        <button @click="onRemoveConfirm()" class="btn btn-danger wd-100p">
          устгах
        </button>
      </div>
    </b-modal>

    <b-modal v-model="mdlAlert.show" title="Сануулга илгээх" hide-footer>
      <Select v-model="mdlAlert.kickedFlag" class="wd-100p">
        <Option :value="0" label="Сануулах">Сануулах</Option>
        <Option :value="9000" label="Шалгалтнаас хасах"
          >Шалгалтнаас хасах</Option
        >
      </Select>

      <Input
        v-model="mdlAlert.msg"
        type="textarea"
        :rows="4"
        placeholder="Тайлбар бичнэ үү..."
        class="mg-t-10"
      />

      <div class="text-center pd-t-10">
        <button
          @click="onNotificationConfirm()"
          class="btn btn-primary wd-100p"
        >
          Илгээх
        </button>
      </div>
    </b-modal>

    <b-sidebar
      v-model="filled.sidebar"
      right
      backdrop
      title="Бөглөсөн"
      width="90vw"
      header-class="primary"
      @change="visibleChanged"
    >
      <div class="container-fluid">
        <div class="row bg-white bd-l">
          <form-filled
            :id.sync="filled.frmId"
            :userId="filled.userId"
            :key="filled.key"
            :cid.sync="$props.id"
            @res-finished="resFinished"
          />
        </div>
      </div>
    </b-sidebar>
    <!-- <b-sidebar v-model="certificate.sidebar" right backdrop no-header width="70vw" >
      <file-preview :id.sync="certificate.id" :key="certificate.key" v-if="certificate.render" :force="true" />
    </b-sidebar>-->
    <file-dialog
      :show="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />
    <b-modal v-model="point.modal" title="Нэмэлт оноо" hide-footer>
      <table class="table table-bordered wd-100p" v-if="$store.state.app.activeGroup.id == 9157">
        <tr>
          <th>Дүйцүүлэх эсэх</th>
          <td>
            <select v-model="point.b1" class="form-control" placeholder="Дүйцүүлэх эсэх">
              <option :value="null">Сонгоно уу</option>
              <option :value="true">Дүйцүүлэх</option>
              <option :value="false">Дүйцүүлэхгүй</option>
            </select>
          </td>
        </tr>
        <tr>
          <th>Төрөл</th>
          <td>
            <loc-type-cascader :key="point.key" v-model="point.locTypeCode" :id="point.locTypeCode" locTypekey="exam2025PointType" />
          </td>
        </tr>
        <tr>
          <th>Протокол</th>
          <td>
            <simple-uploader
                @on-success="fileUploadedSimple($event)"
                :propBoxId="0"
                :propObjectId="'0'"
                :propObjectTypeId="6"
                style="width:100%; max-width: 100%"
              >
                <div slot="trigger" class="wd-100p">
                  <a
                    v-if="
                      point.thirdAttachId == 0 ||
                        point.thirdAttachId == null
                    "
                    class="dropdown-item"
                    >Компьютероос хуулах
                  </a>
                  <div v-else class="btn-group wd-100p">
                    <div
                      class="btn btn-outline-success"
                      @click.stop="
                        showAttach(point.thirdAttachId)
                      "
                    >
                      <feather type="eye"></feather>Файл харах
                    </div>
                    <div
                      class="btn btn-danger"
                      @click.prevent.stop="
                        point.thirdAttachId = null
                      "
                    >
                      <feather type="x"></feather>Салгах
                    </div>
                  </div>
                </div>
              </simple-uploader>
          </td>
        </tr>
      </table>
      
      <!-- {{ point.thirdAttachId }} -->
      
      <Input
        v-model="point.descr"
        type="textarea"
        :rows="4"
        placeholder="Тайлбар бичнэ үү..."
        class="mg-t-10"
      />
      <Input
        v-model="point.point"
        type="text"
        placeholder="Оноо..."
        class="mg-t-10"
      />

      <div class="text-center pd-t-10">
        <button @click="savePoint()" class="btn btn-primary wd-100p">
          Хадгалах
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";
import VirtualList from "vue-virtual-scroll-list";
import ItemUser from "./userVirtualTheme.vue";
import { romanize, alphabetize } from "@/libs/tools";
import { request } from "@/api/all";
import "element-ui/lib/theme-chalk/index.css";
import { Input, Select, Option } from "element-ui";

const moment = require("moment");
var _ = require("lodash");

export default {
  components: {
    "virtual-list": VirtualList,
    vueCustomScrollbar,
    Input,
    Select,
    Option,
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    formFilled: () => ({
      component: import("@/components/modules/form/filled"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    id: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      config: {
        exam: {
          id: 0
        },
        course: {
          solveResult: 0
        }
      },
      users: [],
      usersRaw: [],
      ItemUser: ItemUser,
      mdlAlertDeleteLog: {
        show: false,
        formId: 0,
        userId: ""
      },
      mdlAlert: {
        show: false,
        msg: "",
        type: 0,
        userId: ""
      },
      filled: {
        userId: "",
        frmId: null,
        form: {
          questions: []
        },
        key: 0,
        sidebar: false
      },
      certificate: {
        id: 0,
        sidebar: false,
        render: false,
        key: 0
      },
      point: {
        userId: "",
        b1: null,
        locTypeCode: null,
        thirdAttachId: null,
        descr: "",
        point: 0,
        modal: false,
        key: 0
      },
      rdy: false,
      fileDialog: {
        show: false,
        id: 0
      },
      listKey: 0,

      dnmcSrch: {
        register: "",
        loginName: "",
        lastName: "",
        firstName: ""
      }
    };
  },
  mounted() {},
  methods: {
    fileUploadedSimple(e) {
      // console.log('fileUploadedSimple', e);
      this.point.thirdAttachId = e.uploadedAttachmentId;
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "V2/learn/CourseAnnualData" },
        params: { id: this.id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          // console.log(res.data);
          this.config = res.data.config;
          this.usersRaw = res.data.list;
          this.users = res.data.list;
          this.rdy = true;
        }
      });
    },
    search() {
      let _loginName = this.dnmcSrch.loginName.toLowerCase();
      let _lastName = this.dnmcSrch.lastName.toLowerCase();
      let _firstName = this.dnmcSrch.firstName.toLowerCase();
      let _register = this.dnmcSrch.register.toLowerCase();

      this.users = this.usersRaw.filter(u => {
        return (
          u.user.loginName.toLowerCase().indexOf(_loginName) > -1 &&
          u.user.lastName != null &&
          u.user.lastName.toLowerCase().indexOf(_lastName) > -1 &&
          u.user.firstName != null &&
          u.user.firstName.toLowerCase().indexOf(_firstName) > -1 &&
          u.user.register != null &&
          u.user.register.toLowerCase().indexOf(_register) > -1
          //   (u.ln!=null && u.ln.toLowerCase().indexOf(_ln) > -1) &&
          //   (u.ps!=null && u.ps.toLowerCase().indexOf(_ps) > -1) &&
          //   (u.m!=null && u.m.toLowerCase().indexOf(_m) > -1) &&
          //   (u.rg!=null && u.rg.toLowerCase().indexOf(_rg) > -1) &&
          //   (u.ml!=null && u.ml.toLowerCase().indexOf(_ml) > -1)
          // )
          //  && (this.filterParam.userIds.length==0 && this.filterParam.userDepCur==null? true: hasOneOf(this.filterParam.userIds, [u.key]) );
        );
      });
    },
    reset() {
      this.dnmcSrch.loginName = "";
      this.dnmcSrch.lastName = "";
      this.dnmcSrch.firstName = "";
      this.dnmcSrch.register = "";
      this.init();
    },
    getScrollHeight() {
      let mh = 52;
      return `calc(${window.innerHeight}px - ${mh}px);`;
    },
    getScrollHeightMain() {
      let mh = 85;
      return `calc(${window.innerHeight}px - ${mh}px);`;
    },
    onRemove(e) {
      this.mdlAlertDeleteLog.userId = e;
      this.mdlAlertDeleteLog.show = true;
    },
    onRemoveConfirm() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "Learn/deleteExamPassLog" },
        data: {
          courseId: this.id,
          userId: this.mdlAlertDeleteLog.userId,
          formId: this.config.exam.id
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.mdlAlertDeleteLog.show = false;
        }
      });
    },
    onNotification(e) {
      this.mdlAlert.userId = e;
      this.mdlAlert.show = true;
    },
    onNotificationConfirm() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "Learn/kickFromExam" },
        data: {
          courseId: this.id,
          userId: this.mdlAlert.userId,
          msg: this.mdlAlert.msg,
          kickedFlag: this.mdlAlert.kickedFlag
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.mdlAlert.show = false;
          this.$bvToast.toast("Сануулга амжилттай илгээлээ", {
            title: "Мэдэгдэл",
            autoHideDelay: 500,
            appendToast: true
          });
        }
      });
    },
    onFilled(e) {
      let servertime = null;
      request({
        api: { method: "GET", url: "servertime" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          servertime = res.data.now;
          if(this.config.exam?.endDate){
            let endDate = moment(this.config.exam.endDate);
            let sixMonthsAgo = moment(servertime).subtract(6, 'months');
            // console.log(endDate, sixMonthsAgo);
            if(endDate.isBefore(sixMonthsAgo)) {
              this.$bvToast.toast("Хэрхэн бөглөснийг 6 сарын дотор харах боломжтой", {
                title: "Мэдэгдэл",
                variant: "warning",
                autoHideDelay: 1500,
                appendToast: true
              });
              return;
            }else{
              this.filled.key++;
              this.filled.frmId = null;
              this.filled.userId = e;
              this.filled.frmId = this.config.exam.id;
              this.filled.sidebar = true;
            }
          }else {
            this.filled.key++;
            this.filled.frmId = null;
            this.filled.userId = e;
            this.filled.frmId = this.config.exam.id;
            this.filled.sidebar = true;
          }
        }
      });
      

      // this.filled.key++;
      // this.filled.frmId = null;
      // this.filled.userId = e;
      // this.filled.frmId = this.config.exam.id;
      // this.filled.sidebar = true;
      // this.toggleBodyClass("addClass", "dynamic-locker");
      // request({
      //   api: { method: "POST", url: "v2/Form/ExamFilledData" },
      //   data: {
      //     id: this.config.exam.id,
      //     userId: this.filled.userId
      //   },
      //   store: this.$store
      // }).then(res => {
      //   this.toggleBodyClass("removeClass", "dynamic-locker");
      //   if (res != false) {
      //     this.filled.form = res.data.form;
      //     this.filled.sidebar = true;
      //   }
      // });
    },
    resultFinishFlag() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "v2/Form/SetResultFinishFlag" },
        data: {
          courseId: this.id,
          resultId: this.filled.form.resultId
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.init();
        }
      });
    },
    getAnswerIcon(q, a) {
      let rv = "";
      if (q.t == 3) {
        if (a.if && a.isTrue) {
          rv = "check-square";
        } else if (!a.if && a.isTrue) {
          rv = "check-square";
        } else if (a.if && !a.isTrue) {
          rv = "minus-square";
        } else {
          rv = "square";
        }
      } else if (q.t == 4) {
        if (a.if && a.isTrue) rv = "check-circle";
        else if (!a.if && a.isTrue) rv = "check-circle";
        else if (a.if && !a.isTrue) rv = "times-circle";
        else rv = "circle";
      }
      return rv;
    },
    getAnswerColor(q, a) {
      let rv = "";
      if (q.t == 3 || q.t == 4) {
        if (!q.isFilled && a.isTrue) {
          rv = "warning";
        } else if (q.isFilled && a.isTrue && !a.if) {
          rv = "primary";
        } else if (a.if && a.isTrue) {
          rv = "success";
        } else if (!a.if && a.isTrue) {
          rv = "success";
        } else if (a.if && !a.isTrue) {
          rv = "danger";
        }
      } else if (q.t == 7 || q.t == 21) {
        if (a.if && a.isTrue) {
          rv = "success";
        } else if (a.if && !a.isTrue) {
          rv = "danger";
        } else if (!a.if) {
          rv = "warning";
        }
      } else if (q.t == 22) {
        if (a.if && a.isTrue) {
          rv = "success";
        } else if (a.if && !a.isTrue) {
          rv = "danger";
        } else if (!a.if) {
          rv = "warning";
        }
      }
      return rv;
    },
    getQuestionColor(q) {
      let rv = "";
      if (q.isFilled) {
        if ((q.t == 1 || q.t == 11) && q.point > 0) {
          rv = "bg-success text-white";
        } else if (q.as.filter(x => x.if && x.isTrue).length) {
          rv = "bg-success text-white";
        } else if (q.as.filter(x => !x.if && x.isTrue).length) {
          rv = "bg-danger text-white";
        }
      } else {
        rv = "bg-warning text-white";
      }
      return rv;
    },
    romanize(v) {
      return romanize(v);
    },
    alphabetize(v) {
      return alphabetize(v);
    },
    saveExamQuestionPoint(q) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "v2/Form/SetExamQuestionPoint" },
        data: {
          courseId: this.id,
          formId: this.config.exam.id,
          responseId: q.responseId,
          point: q.point
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.$bvToast.toast("Амжилттай хадгаллаа", {
            title: "Мэдэгдэл",
            autoHideDelay: 500,
            appendToast: true
          });
          this.init();
          this.onFilled(this.filled.userId);
        }
      });
    },
    showAttach(id) {
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
    onCertificate(e) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "V2/Learn/CreateCertificateFromTemplate" },
        data: {
          id: this.id,
          userId: e
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          if (res.data.file.id != 0) {
            this.showAttach(res.data.file.id);
          } else {
            this.$bvToast.toast(
              "Сертификат үүсгэхэд алдаа гарлаа. ахин оролдоно уу",
              {
                title: "Мэдэгдэл",
                autoHideDelay: 500,
                appendToast: true
              }
            );
          }
        }
      });
    },
    onPoint(e) {
      // console.log(e);
      this.point.descr = e.yavtsData.pointInfo;
      this.point.point = e.yavtsData.pointAdd;
      this.point.userId = e.userId;
      this.point.thirdAttachId = e.yavtsData.thirdAttachId;
      this.point.locTypeCode = e.yavtsData.locTypeId1;
      this.point.b1 = e.yavtsData.b1;
      this.point.key++;
      this.$nextTick(() => {
        this.point.modal = true;
      });
    },
    savePoint() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TaskInUser/setUserAddedPoint" },
        data: {
          addedInfo: this.point.descr,
          addedPerc: this.point.point,
          taskId: this.id,
          userId: this.point.userId,
          locTypeId1: this.point.locTypeCode,
          thirdAttachId: this.point.thirdAttachId,
          b1: this.point.b1
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          // if(this.users.filter(x=>x.userId == this.point.userId).length>0){
          //   this.users.filter(x=>x.userId == this.point.userId)[0].yavtsData.pointAdd = this.point.point;
          // };
          //this.listKey++;

          this.point.modal = false;
          this.init();
          this.$bvToast.toast("Амжилттай", {
            title: "Мэдэгдэл",
            autoHideDelay: 500,
            appendToast: true
          });
        }
      });
    },
    onCertificateRe(e) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "v2/learn/RemoveCertificateFile" },
        data: {
          id: this.id,
          userId: e
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //this.point.modal = false;
          //this.init();
          this.$bvToast.toast("Амжилттай", {
            title: "Мэдэгдэл",
            autoHideDelay: 500,
            appendToast: true
          });
        }
      });
    },
    onChangeShareflag(e) {
      //console.log('onChangeShareflag', e);
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TaskInUser/SetExecuteFlag" },
        data: {
          taskId: this.id,
          userId: e.userId,
          executeFlag: e.flag
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log(res);
          this.init();
        }
      });
    },
    generateMissingWords(q) {
      let rv = q.q;
      for (let k = 1; k <= q.answerGroupCount; k++) {
        let at = q.as.filter(x => x.g == k);
        let bldr = ``;
        if (at.length) {
          if (at.filter(x => x["if"] == true && x["isTrue"] == true).length) {
            bldr = `<span class="badge badge-success">${
              at.filter(x => x["isTrue"] == true)[0].a
            }</span>`;
          } else if (
            at.filter(x => x["if"] == true && x["isTrue"] != true).length
          ) {
            bldr = `<span class="badge badge-danger">${
              at.filter(x => x["if"] == true)[0].a
            }</span>`;
            bldr += ` ( <span class="badge badge-success">${
              at.filter(x => x["isTrue"] == true)[0].a
            }</span> )`;
          } else if (at.filter(x => x["isTrue"] == true).length) {
            bldr = `<span class="badge badge-warning">${
              at.filter(x => x["isTrue"] == true)[0].a
            }</span>`;
          }
        }

        rv = rv.replace("{" + k + "}", bldr);
      }
      //console.log(q);
      return rv;
    },
    sortedAnswers(q, f) {
      let rv = [];
      rv = _.orderBy(q.as, [f], ["asc"]);
      return rv;
    },
    visibleChanged(e) {
      if (!e) {
        this.filled.key = 0;
        this.filled.frmId = null;
        this.filled.userId = null;
      }
    },
    resFinished(){
      this.init();
    }
  },
  computed: {
    courseId() {
      return this.id;
    }
  },
  watch: {
    courseId(val) {
      if (val > 0) {
        this.init();
      }
    }
  }
};
</script>

<style lang="scss"></style>
